import { useMemo } from 'react';
import { resolveBool } from '@/utils/resolvers';

export const useComponentProps = (brProps: Br.Props = {}) => {
  const { component } = brProps;
  const { label, models } = useMemo(() => component?.model || {}, [component?.model]);
  const { componentParameterMap } = models || component?.getModels() || {};

  const isHidden = useMemo(() => {
    return /on/.test(
      models?.['com.onehippo.cms7.targeting.TargetingParameterUtil.hide'] ||
        componentParameterMap?.['com.onehippo.cms7.targeting.TargetingParameterUtil.hide'] ||
        'off',
    );
  }, [componentParameterMap, models]);

  const componentProps = useMemo(() => {
    const { jumplink, ...props } = componentParameterMap || {};
    const jumplinkLabel =
      componentParameterMap?.['anchor-label'] || componentParameterMap?.anchorLabel;

    return {
      hasJumplink: jumplinkLabel && resolveBool({ rawVal: jumplink }),
      jumplinkLabel,
      ...props,
    };
  }, [componentParameterMap]);

  return {
    label,
    isHidden,
    ...componentProps,
  };
};
